import { z } from 'zod';

interface FieldValidation {
    maxLength?: number;
    pattern?: RegExp;
    patternMessage?: string;
}

export interface ProviderNameValidation {
    firstName?: FieldValidation;
    lastName?: FieldValidation;
}

const providerValidationMap: Record<string, ProviderNameValidation> = {
    synchrony: {
        firstName: {
            maxLength: 20,
            pattern: /^[a-zA-Z ]+$/,
            patternMessage: 'First name can only contain letters and spaces',
        },
        lastName: {
            maxLength: 25,
            pattern: /^[a-zA-Z\-' ]+$/,
            patternMessage: 'Last name can only contain letters, hyphens, apostrophes, and spaces',
        },
    },
};

export function getProviderValidation(provider?: string): ProviderNameValidation | undefined {
    if (!provider) {
        return undefined;
    }
    return providerValidationMap[provider.toLowerCase()];
}

export function applyProviderNameValidation(
    fieldSchema: z.ZodString,
    fieldValidation?: FieldValidation,
): z.ZodString {
    if (!fieldValidation) {
        return fieldSchema;
    }

    let result = fieldSchema;

    if (fieldValidation.maxLength) {
        result = result.max(fieldValidation.maxLength, {
            message: `Must be ${fieldValidation.maxLength} characters or fewer`,
        });
    }

    if (fieldValidation.pattern) {
        result = result.regex(fieldValidation.pattern, {
            message: fieldValidation.patternMessage ?? 'Contains characters that are not allowed',
        });
    }

    return result;
}
